export default __webpack_public_path__ + "static/media/HOTFROG.a35c1bd8.png";